

<template>
  <div class="container" style="margin-top: 42px;">
    <el-row class="faq-container" style="padding:0 110px 48px 0;">
      <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
        <div class="faq-item" @click="handleClick(faq)">
          <h3 class="show-ellipsis">{{ faq.question }}</h3>
            <div class="faq-answer show-ellipsis">
               <i>答</i> A: {{ faq.answer }}
            </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
props:{
  activeName:{
    type:String
  }
},
components: {

},
created() {
 
},
data() {
  return {
    faqs: [
    {
      id:'1',
      question: '【海运】海运整箱运输时效性如何？',
      answer: '我司在美国、加拿大、日本、英国、德国、法国、意大利、西班牙八个国家航线均有长期合作的船公司，全部提供港到港时效最快的直航船，有多个船公司的多条航线随时根据客户的货期安排不同的船期。'
    },
    {
      id:'2',
      question: '【空运】美国空运安排什么时候航班？',
      answer: '交货后的航班安排，我司已经有固定的航班安排，固定每周三/六的航班，起飞后，第二天到港。'
    },
    {
      id:'3',
      question: '【国际快递】货物交由DHL,UPS,FED,TNT转运途中，能否直接申请更改地址或者退运？',
      answer: '不能；只能转运到目的国清关后，尝试申请更改或退运，会有相关费用产生。'
    },
    {
      id:'4',
      question: '【空运】FEDEX追踪单号什么时候生成?',
      answer: 'FEDEX追踪单号在货物交至我司后即可生成，美国清关放行后即可上网查询转运轨迹'
    }
    // 其他的FAQ对象...
  ]
  };
},
methods: {
  handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
}

};
</script>
<style src="../index.css" scoped>


</style>